const capitalize = (input: string) => (input ? input.charAt(0).toUpperCase() + input.slice(1) : "");

export default capitalize;
